import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './MerchantAdmin.css';
import { useCurrency } from '../context/CurrencyContext';

function ProductList({ merchantId }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const currencySymbol = useCurrency();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newProduct, setNewProduct] = useState({
    name: '',
    description: '',
    price: '',
    custom_category_id: '',
    images: ''
  });

  const fetchProducts = () => {
    setLoading(true);
    axios.get('/api/merchant/products', {
      headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
    })
    .then(res => {
      setProducts(res.data);
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      alert('获取商品列表失败');
      setLoading(false);
    });
  };

  const fetchCategories = () => {
    axios.get('/api/merchant/custom-categories', {
      headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
    })
    .then(res => {
      setCategories(res.data);
    })
    .catch(err => {
      console.error('获取分类失败', err);
    });
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const handleAddProduct = async () => {
    if (!newProduct.name || !newProduct.price) {
      alert('请填写商品名称和价格');
      return;
    }
    
    let imagesArray = [];
    if (newProduct.images.trim()) {
      imagesArray = newProduct.images.split(/[,\s]+/).filter(url => url.trim());
    }
    
    const payload = {
      name: newProduct.name,
      description: newProduct.description,
      price: parseFloat(newProduct.price),
      custom_category_id: newProduct.custom_category_id || null,
      images: imagesArray
    };
    try {
      await axios.post('/api/merchant/products', payload, {
        headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
      });
      alert('添加成功');
      setShowModal(false);
      setNewProduct({ name: '', description: '', price: '', custom_category_id: '', images: '' });
      fetchProducts();
    } catch (err) {
      console.error(err);
      alert('添加失败');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定要删除这个商品吗？删除后无法恢复')) return;
    try {
      await axios.delete(`/api/merchant/products/${id}`, {
        headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
      });
      setProducts(products.filter(p => p.id !== id));
    } catch (err) {
      alert('删除失败');
    }
  };

  const handleToggleSoldOut = async (id, currentStatus) => {
    const newStatus = currentStatus === 1 ? '上架' : '售罄';
    const confirmMsg = `确定要将此商品${newStatus}吗？`;
    if (!window.confirm(confirmMsg)) return;
    
    try {
      const product = products.find(p => p.id === id);
      await axios.put(`/api/merchant/products/${id}`, {
        ...product,
        is_sold_out: currentStatus === 1 ? 0 : 1
      }, {
        headers: { 'x-telegram-init-data': window.Telegram.WebApp.initData }
      });
      fetchProducts();
    } catch (err) {
      alert('操作失败');
    }
  };

  const getCategoryName = (categoryId) => {
    const cat = categories.find(c => c.id === categoryId);
    return cat ? cat.name : '';
  };

  if (loading) return <div style={{ padding: '20px', textAlign: 'center' }}>加载中...</div>;

  return (
    <div style={{ padding: '16px', background: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0, color: '#1a1a1a' }}>商品管理</h2>
        <button 
          onClick={() => setShowModal(true)} 
          style={{
            background: '#ff6b6b',
            color: 'white',
            border: 'none',
            padding: '8px 20px',
            borderRadius: '30px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
        >
          + 添加商品
        </button>
      </div>

      {products.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', background: 'white', borderRadius: '16px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>🍽️</div>
          <p style={{ color: '#999', margin: 0 }}>暂无商品，点击上方添加</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {products.map(product => (
            <div key={product.id} style={{
              background: 'white',
              borderRadius: '16px',
              padding: '16px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              border: '1px solid #eee'
            }}>
              <div style={{ display: 'flex', gap: '16px' }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  background: '#f5f5f5',
                  flexShrink: 0
                }}>
                  {product.images && product.images[0] ? (
                    <img src={product.images[0]} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', color: '#ccc' }}>🍽️</div>
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '4px', color: '#1a1a1a' }}>{product.name}</div>
                      <div style={{ fontSize: '13px', color: '#999', marginBottom: '8px', lineHeight: '1.4' }}>{product.description || '暂无描述'}</div>
                      <div style={{ fontWeight: '600', fontSize: '18px', color: '#1a1a1a' }}>
                        {currencySymbol}{product.price}
                      </div>
                      {product.custom_category_id && (
                        <span style={{ fontSize: '11px', background: '#f0f0f0', padding: '2px 8px', borderRadius: '12px', color: '#666', marginTop: '6px', display: 'inline-block' }}>
                          {getCategoryName(product.custom_category_id)}
                        </span>
                      )}
                    </div>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', alignItems: 'flex-end' }}>
                      <button
                        onClick={() => handleToggleSoldOut(product.id, product.is_sold_out)}
                        style={{
                          background: 'transparent',
                          color: product.is_sold_out === 1 ? '#f44336' : '#4caf50',
                          border: 'none',
                          fontSize: '13px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          padding: '4px 8px'
                        }}
                      >
                        {product.is_sold_out === 1 ? '售罄' : '在售'}
                      </button>
                      <Link
                        to={`/products/edit/${product.id}`}
                        style={{
                          background: 'transparent',
                          color: '#666',
                          border: 'none',
                          fontSize: '13px',
                          textDecoration: 'none',
                          cursor: 'pointer',
                          padding: '4px 8px'
                        }}
                      >
                        编辑
                      </Link>
                      <button
                        onClick={() => handleDelete(product.id)}
                        style={{
                          background: 'transparent',
                          color: '#f44336',
                          border: 'none',
                          fontSize: '13px',
                          cursor: 'pointer',
                          padding: '4px 8px'
                        }}
                      >
                        删除
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          backdropFilter: 'blur(4px)'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '24px',
            padding: '24px',
            width: '90%',
            maxWidth: '400px',
            maxHeight: '80vh',
            overflow: 'auto',
            boxShadow: '0 20px 40px rgba(0,0,0,0.2)'
          }}>
            <h2 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '20px', color: '#1a1a1a' }}>添加商品</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px', display: 'block' }}>商品名称 *</label>
                <input
                  type="text"
                  placeholder="例如：招牌炒饭"
                  value={newProduct.name}
                  onChange={e => setNewProduct({ ...newProduct, name: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '12px', fontSize: '14px', outline: 'none' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px', display: 'block' }}>描述</label>
                <textarea
                  rows="3"
                  placeholder="商品描述..."
                  value={newProduct.description}
                  onChange={e => setNewProduct({ ...newProduct, description: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '12px', fontSize: '14px', fontFamily: 'inherit', resize: 'vertical', outline: 'none' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px', display: 'block' }}>价格 *</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="例如：28.00"
                  value={newProduct.price}
                  onChange={e => setNewProduct({ ...newProduct, price: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '12px', fontSize: '14px', outline: 'none' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px', display: 'block' }}>分类</label>
                <select
                  value={newProduct.custom_category_id}
                  onChange={e => setNewProduct({ ...newProduct, custom_category_id: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '12px', fontSize: '14px', background: 'white', outline: 'none' }}
                >
                  <option value="">无分类</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px', display: 'block' }}>图片 URL</label>
                <input
                  type="text"
                  placeholder="支持多张，用逗号或空格分隔，例如：https://xxx.jpg, https://yyy.jpg"
                  value={newProduct.images}
                  onChange={e => setNewProduct({ ...newProduct, images: e.target.value })}
                  style={{ width: '100%', padding: '12px', border: '1px solid #e0e0e0', borderRadius: '12px', fontSize: '14px', outline: 'none' }}
                />
                <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                  支持多张图片，用逗号或空格分隔
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}>
                <button
                  onClick={() => setShowModal(false)}
                  style={{
                    background: 'transparent',
                    color: '#666',
                    border: '1px solid #e0e0e0',
                    padding: '10px 20px',
                    borderRadius: '30px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  取消
                </button>
                <button
                  onClick={handleAddProduct}
                  style={{
                    background: '#ff6b6b',
                    color: 'white',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '30px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer'
                  }}
                >
                  确认添加
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductList;